/** Grouped muscle action sections for admin exercise form. */

export type MuscleActionSection = {
  id: string;
  label: string;
  actions: readonly string[];
};

export const MUSCLE_ACTION_SECTIONS: MuscleActionSection[] = [
  {
    id: "contraction",
    label: "Contraction Type",
    actions: ["Concentric", "Eccentric", "Isometric", "Plyometric"],
  },
  {
    id: "hip",
    label: "Hip",
    actions: [
      "Hip extension",
      "Hip flexion",
      "Hip abduction",
      "Hip adduction",
      "Hip external rotation",
      "Hip internal rotation",
    ],
  },
  {
    id: "knee-ankle",
    label: "Knee / Ankle",
    actions: [
      "Knee extension",
      "Knee flexion",
      "Ankle dorsiflexion",
      "Ankle plantarflexion",
    ],
  },
  {
    id: "shoulder",
    label: "Shoulder",
    actions: [
      "Shoulder flexion",
      "Shoulder extension",
      "Shoulder abduction",
      "Shoulder adduction",
      "Shoulder external rotation",
      "Shoulder internal rotation",
    ],
  },
  {
    id: "scapular",
    label: "Scapular",
    actions: [
      "Scapular protraction",
      "Scapular retraction",
      "Scapular upward rotation",
      "Scapular depression",
    ],
  },
  {
    id: "elbow-wrist",
    label: "Elbow / Wrist / Grip",
    actions: [
      "Elbow flexion",
      "Elbow extension",
      "Wrist flexion",
      "Wrist extension",
      "Grip / loaded hold",
    ],
  },
  {
    id: "core-spine",
    label: "Core / Spine",
    actions: [
      "Anti-extension",
      "Anti-flexion",
      "Anti-rotation",
      "Anti-lateral flexion",
      "Trunk rotation",
      "Trunk flexion",
      "Trunk extension",
      "Lateral flexion",
    ],
  },
  {
    id: "functional",
    label: "Integrated / Functional",
    actions: [
      "Load carriage",
      "Gait / locomotion",
      "Force transfer",
      "Perturbation control",
      "Postural control",
      "Balance strategy",
      "Landing / deceleration",
      "Acceleration",
    ],
  },
];

/** Flat list of all muscle action labels (for filters and validation). */
export const ALL_MUSCLE_ACTIONS: readonly string[] = MUSCLE_ACTION_SECTIONS.flatMap(
  (s) => s.actions
);
